import './sass/projects.scss';
import { GitHub, LanguageTwoTone } from '@material-ui/icons';
import VanillaTilt from 'vanilla-tilt';
import { motion } from "framer-motion";
import { getSectionAnimation } from '../animations/sections';

function Projects() {
  const projects = [
    {
      type: `GSoC'23 Project`,
      name: 'Automatic Management of ZeroTier Tunnels',
      pic: 'project-1.png',
      desc: `I spearheaded the development of ZeroTier Tunnel automation in OpenWISP.
      Our newly developed ZeroTier VPN backend simplifies setting up ZeroTier tunnels
      on OpenWRT devices, streamlining the configuration process for our users,
      also designed and implemented a parser in OpenWISP Network Topology to process 
      ZeroTier peers information, improving network visualization and monitoring`,
      techList: ['Python', 'Django', 'OpenWrt', 'ZeroTier', 'VPN'],
      links: [
        {
          github: 'https://github.com/openwisp/openwisp-controller',
          website: 'https://aryamanz29.medium.com/add-support-for-automatic-management-of-zerotier-tunnels-791be96903bf',
        },
      ],
    },
    {
      type: `GSoC'22 Project`,
      name: 'Iperf3 Support for OpenWISP Monitoring',
      pic: 'project-2.png',
      desc: `Developed an Iperf3 check for OpenWISP Monitoring,
      that collects network performance metrics such as bandwidth,
      jitter, transferred data, and datagram loss for OpenWrt devices. Introduced
      a novel Iperf3 lock mechanism for concurrent execution of
      checks and integrated RSA authentication for secure connections`,
      techList: ['Python', 'Django', 'OpenWrt', 'Iperf3', 'JavaScript', 'Network Monitoring'],
      links: [
        {
          github: 'https://github.com/openwisp/openwisp-monitoring#iperf3-1',
          website: 'https://aryamanz29.medium.com/iperf-check-to-openwisp-monitoring-gsoc22-project-report-2661eddd3f77',
        },
      ],
    },
  ];
  VanillaTilt.init(document.querySelectorAll('.project-image'), {
    max: 20,
    speed: 400,
    glare: true,
    'max-glare': 0.2,
    gyroscope: true,
  });
  return (
  <motion.section {...getSectionAnimation}>
    <section id="projects" className="projects">
      <h2 className="numbered-heading">My Recent Works</h2>
      <ul>
        {projects.map((project, i) => (
          <li className="project-inner" key={i}>
            <div className="project-content">
              <div>
                <p className="project-type">{project.type}</p>
                <h3 className="project-title">
                  <a href={project.links[0].website}>{project.name}</a>
                </h3>
                <div className="project-desc">
                  <p style={{fontSize : "18px", wordBreak: "break-word"}}>{project.desc}</p>
                </div>
                <ul className="project-tech-list">
                  {project.techList.map((tech, index) => (
                    <li key={index}>{tech}</li>
                  ))}
                </ul>
                <div className="project-links">
                  <a href={project.links[0].github}>
                    <GitHub />
                  </a>
                  <a href={project.links[0].website}>
                    <LanguageTwoTone fontSize="medium" />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-image">
              <a href={project.links[0].website}>
                <div className="img">
                  <div>
                    <img src={project.pic} alt={project.pic} />
                  </div>
                </div>
              </a>
            </div>
          </li>
        ))}
      </ul>
    </section>
  </motion.section>
  );
}
export default Projects;
